module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="nav-bar">\n    <div class="' +
__e( newDashboardExperience ? "fastr-frontend-logo-container" : "logo-container" ) +
'">\n        <a href="' +
__e( newDashboardExperience ? config.contentControlUrl : "#" ) +
'" class="logo"></a>\n    </div>\n    ';
 if (!newDashboardExperience) { ;
__p += '\n    <div class="project-buttons-container">\n        <div class="project-selector-btn';
 if (currentProject) { ;
__p += ' in-project-context';
 } ;
__p += '">\n            <div class="project-btn-icon"></div>\n            <div class="project-btn-txt">Projects</div>\n        </div>\n        ';
 if (currentProject) { ;
__p += '\n            <a class="project-context-btn" href="#project/' +
__e( currentProjectId ) +
'">' +
__e( currentProjectName ) +
'</a>\n        ';
 } ;
__p += '\n    </div>\n    ';
 } ;
__p += '\n    <div class="spacer"></div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label"></div>\n    </div>\n    <div class="current-principal"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/NavBarView.tpl
// module id = 2808
// module chunks = 0